var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnYourStoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 130,
    viewBox: "0 0 153 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2028 104V123.27C20.2028 124.767 21.0056 126.148 22.3034 126.893C23.6032 127.635 25.2005 127.625 26.4899 126.868C41.9946 117.748 64.5001 104 64.5001 104H20.2028Z",
    fill: "url(#paint0_linear_105_12768)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.793 10.5215C132.793 7.73049 131.684 5.05591 129.713 3.08221C127.739 1.10852 125.063 0 122.274 0C97.4308 0 35.3622 0 10.5215 0C7.73049 0 5.05383 1.10852 3.08221 3.08221C1.10851 5.05591 0 7.73049 0 10.5215V93.4626C0 96.2536 1.10851 98.9303 3.08221 100.902C5.05383 102.876 7.73049 103.984 10.5215 103.984H122.274C125.063 103.984 127.739 102.876 129.713 100.902C131.684 98.9303 132.793 96.2536 132.793 93.4626C132.793 73.5259 132.793 30.4582 132.793 10.5215Z",
    fill: "url(#paint1_linear_105_12768)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4183 108.776V124.911C80.4183 127.267 82.3296 129.178 84.686 129.178H96.2848C98.6433 129.178 100.555 127.267 100.555 124.911V115.537L140.347 128.904C143.275 129.885 146.499 129.401 149.005 127.598C151.513 125.795 153 122.893 153 119.805C153 104.639 153 80.0294 153 64.8616C153 61.7732 151.513 58.874 149.005 57.0708C146.499 55.2677 143.275 54.781 140.347 55.7647C121.267 62.1725 85.8111 74.0812 71.2112 78.9853C67.3033 80.2977 64.6703 83.958 64.6703 88.0822V96.5864C64.6703 100.708 67.3033 104.371 71.2112 105.683L80.4183 108.776Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4183 108.776V124.911C80.4183 127.267 82.3296 129.178 84.686 129.178H96.2848C98.6433 129.178 100.555 127.267 100.555 124.911V115.537L140.347 128.904C143.275 129.885 146.499 129.401 149.005 127.598C151.513 125.795 153 122.893 153 119.805C153 104.639 153 80.0294 153 64.8616C153 61.7732 151.513 58.874 149.005 57.0708C146.499 55.2677 143.275 54.781 140.347 55.7647C121.267 62.1725 85.8111 74.0812 71.2112 78.9853C67.3033 80.2977 64.6703 83.958 64.6703 88.0822V96.5864C64.6703 100.708 67.3033 104.371 71.2112 105.683L80.4183 108.776Z",
    fill: "url(#paint2_linear_105_12768)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4182 108.776V124.911C80.4182 127.267 82.3295 129.178 84.6859 129.178H96.2847C98.6432 129.178 100.554 127.267 100.554 124.911V115.537L80.4182 108.776Z",
    fill: "url(#paint3_linear_105_12768)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2091 46.0127C89.6442 46.7448 90.5468 48.2214 90.5468 49.8312C90.5468 51.443 89.6442 52.9175 88.2091 53.6517C79.3057 58.2043 64.5893 65.7289 56.264 69.9862C54.935 70.6663 53.3461 70.6059 52.0712 69.826C50.7983 69.0461 50.0205 67.6589 50.0205 66.1656C50.0205 57.3516 50.0205 42.3128 50.0205 33.4988C50.0205 32.0055 50.7983 30.6183 52.0712 29.8384C53.3461 29.0585 54.935 28.9982 56.264 29.6782C64.5893 33.9355 79.3057 41.4601 88.2091 46.0127Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_12768",
    x1: -139.086,
    y1: 266.431,
    x2: 184.646,
    y2: 87.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_105_12768",
    x1: -139.086,
    y1: 266.431,
    x2: 184.646,
    y2: 87.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_105_12768",
    x1: 67.1369,
    y1: 129.402,
    x2: 183.965,
    y2: 60.8448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_105_12768",
    x1: 72.5,
    y1: 148.5,
    x2: 129.746,
    y2: 92.0432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnYourStoryIcon);
export default __webpack_public_path__ + "static/media/own-your-story-icon.c081b1bdea95b89169d8f6de24d754b2.svg";
export { ForwardRef as ReactComponent };